
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ArStatementService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  generate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'ar-statement/generateAR', payload, {
        responseType: 'text'
    });
  }
}